import React, { FC } from "react"
import { Card, Row, Typography } from "antd"
const { Text } = Typography;

export interface PlacementCardProp {
    placement: number,
    points: number
}

export const PlacementCard: FC<PlacementCardProp> = (props) => {
    return (
        <Card title={'Rank ' + props.placement} style={{ maxWidth: 200, minWidth: 200 }}>
            <Row justify="space-around">
                <Text strong style={{ fontSize: 20 }}>{props.points + ' Points'}</Text>
            </Row>
        </Card>
    )
}